module.exports = __webpack_public_path__ + "media/images/paypal-1600a8c6.png";